import { Card, Stack, Text } from 'braid-design-system';
import React from 'react';

import CustomSvg from 'src/components/CustomSvg/CustomSvg';

import PrivateSeller from './resources/PrivateSeller.svg';

const HeroImage = () => (
  <Card>
    <Stack space="gutter">
      <Text align="center">
        You&apos;re about to advertise on Australia&apos;s most visited business
        for sale website
      </Text>
      <CustomSvg svg={PrivateSeller} />
    </Stack>
  </Card>
);

export default HeroImage;
